import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { BaseToast } from './BaseToast.tsx';

import LikeNotification from '@/components/Toast/components/LikeNotification.tsx';
import { IToast } from '@/services/ToastService.ts';
import { MessageTypesUI } from '@/enums/viewEnums.ts';
import GiftNotification from '@/components/Toast/components/GiftNotification.tsx';
import { Gender } from '@/enums/apiEnums.ts';
import MatchNotification from '@/components/Toast/components/MatchNotification.tsx';
import { useProfileStore } from '@/store/useProfileStore.ts';
import { routes } from '@/navigation/routes.tsx';
import { Contact } from '@/api/messaging/types.ts';
import SystemNotification from '@/components/Toast/components/SystemNotification.tsx';

export const Toast = ({
  type,
  contact,
  msg
}: {
  type: MessageTypesUI;
  contact?: Contact;
  msg?: string;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { premium } = useProfileStore();

  const renderNotificationContent = (currentToast: IToast) => {
    const type = currentToast.data.type;

    switch (type) {
      case MessageTypesUI.TYPE_MATCH:
        return (
          <MatchNotification
            msg={t('toast.match_notification_msg')}
            onClose={() => toast.dismiss()}
            contact={currentToast.data.contact}
          />
        );
      case MessageTypesUI.TYPE_LIKE:
        return (
          <LikeNotification
            style={premium.isExpired ? { filter: 'blur(3px)' } : {}}
            msg={t('toast.like_notification_msg')}
            onClose={() => toast.dismiss()}
            onClick={() => navigate(routes.likes)}
            contact={currentToast.data.contact}
          />
        );
      case MessageTypesUI.TYPE_GIFT:
        return (
          <GiftNotification
            msg={
              currentToast.data.contact?.gender === Gender.MALE
                ? t('chats.new_gift.m')
                : t('chats.new_gift.f')
            }
            onClose={() => toast.dismiss()}
            onClick={() => navigate(routes.messenger)}
            contact={currentToast.data.contact}
          />
        );
      case MessageTypesUI.TYPE_GIFT_ACCEPT:
      case MessageTypesUI.TYPE_GIFT_REJECT:
        return (
          <GiftNotification
            msg={
              type === MessageTypesUI.TYPE_GIFT_ACCEPT
                ? currentToast.data.contact?.gender === Gender.MALE
                  ? t('toast.gift_accept_notification_msg.m')
                  : t('toast.gift_accept_notification_msg.f')
                : currentToast.data.contact?.gender === Gender.MALE
                  ? t('toast.gift_reject_notification_msg.m')
                  : t('toast.gift_reject_notification_msg.f')
            }
            onClose={() => toast.dismiss()}
            contact={currentToast.data.contact}
          />
        );
      case MessageTypesUI.TYPE_SYSTEM_ERROR:
        return <SystemNotification type="error" msg={msg} />;
      case MessageTypesUI.TYPE_SYSTEM_SUCCESS:
        return <SystemNotification type="success" />;
      case MessageTypesUI.TYPE_SYSTEM_INFO:
        return <SystemNotification type="info" msg={msg} />;
      default:
        return null;
    }
  };

  return (
    <BaseToast toastKey={contact?.hid} role="notification">
      {renderNotificationContent({ data: { type, contact } })}
    </BaseToast>
  );
};
